module.exports = __webpack_public_path__ + "static/img/product3-3.f1e80bb0.png";